export const setLastActiveTime = (documentId) => {
  window.sessionStorage.setItem(
    `${documentId}_lastActiveTime`,
    JSON.stringify(Date.now())
  )
}

export const getLastActiveTime = (documentId) => {
  return window.sessionStorage.getItem(`${documentId}_lastActiveTime`)
}
